import {Injectable} from "@angular/core";
import { HttpService, MainUserService} from "../../app-shared";
import {Observable, ReplaySubject, Subject} from "rxjs";
import {UserNotification} from "./user-notification.models";
import {map} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class UserNotificationService {
  notificationData: ReplaySubject<Array<UserNotification>> = new ReplaySubject(1);
  newNotificationsCounter: Subject<number> = new Subject();

  constructor(private http: HttpService,
              private mainUserService: MainUserService,) {}

  getUserNotifications(): Observable<Array<UserNotification>> {
    const applicationUserId = this.mainUserService.getUserData().userId;
    return this.http.get<Array<UserNotification>>(`getOutletMessages?applicationUserId=${applicationUserId}`)
      .pipe(
        map((res: Array<UserNotification>) => {
          const newCount = res.filter(n => !n?.isRead)?.length;
          this.newNotificationsCounter.next(newCount);
          return res;
        })
      )
  }

  setOutletMessagesIsRead(ids: string[]): Observable<any> {
    return this.http.post<any>(`setOutletMessagesIsRead`, ids).pipe(
      map((res) => {
        return res;
      })
    );
  }
}
